import { BambiMapSearch } from 'src/common/BambiMapView/BambiMapSearch';
import { BambiMapView } from 'src/common/BambiMapView/BambiMapView';
import {
  MapStyleToggle,
  useMapStyleState,
} from 'src/common/BambiMapView/MapStyleToggle';
import colors from 'src/common/theme/colors';
import { AssignmentMarkers } from 'src/features/live-map/LiveMap/AssignmentLiveMapView/AssignmentMarkers';

export function AssignmentLiveMapView() {
  const { mapStyleResource, selectedMapStyle, onSelect } =
    useMapStyleState('map');

  return (
    <BambiMapView
      mapViewProps={{
        mapStyle: mapStyleResource,
      }}
    >
      <BambiMapSearch flyToZoom={12} markerColor={colors.mint} />
      <MapStyleToggle selectedStyle={selectedMapStyle} onSelect={onSelect} />
      <AssignmentMarkers />
    </BambiMapView>
  );
}
